<template>
  <div class="lpMenu">
    <div class="lpMenu__inn">
      <div class="lpMenu__head">
        <img :src="`${imgPath}counselor${menu.menu_id}.png`" alt="" class="lpMenu__image">
        <div class="lpMenu__side">
          <div class="lpMenu__name">{{ menu.name }}</div>
          <h1 class="lpMenu__title">{{ menu.title }}</h1>
          <div v-if="isHoshiHitomi" class="lpMenu__price">
            ¥{{ menu.price }}<small>(税込)</small>
          </div>
          <div v-else-if="subscriptionFlg" class="lpMenu__price">
            <span class="sbsc">¥0</span>
          </div>
          <div v-else-if="menu.price > 0" class="lpMenu__price">
            ¥{{ menu.price }}<small>(税込)</small>
            <span class="sbsc">月額会員は¥0</span>
          </div>
          <div v-else class="lpMenu__price">
            <span class="sbsc">¥{{ menu.price }}</span>
          </div>
        </div>
        <p class="lpMenu__text" v-html="menu.text"></p>
      </div>
      <ul class="menuSub">
        <li v-for="(item, i) in menu.sub_menus" :key="i" class="menuSub__item">
          {{ item }}
        </li>
      </ul>
      <div class="lpMenu__notes" v-if="menu.event || menu.notes">
        ※この商品は
        <template v-if="menu.event">オンラインイベント{{ menu.event}}</template>
        <template v-if="menu.event && menu.notes">、</template>
        <template v-if="menu.notes">占いサイト{{ menu.notes }}の一部</template>
        と同じ内容のものになります。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "lpMenu",
  props: {
    menu: {
      type: Object,
      default () {
        return {}
      }
    },
    imgPath: {
      type: String,
      default: '',
    },
    subscriptionFlg: Boolean,
    isHoshiHitomi: Boolean,
  },
}
</script>

<style scoped lang="scss">
.lpMenu {
  padding: 5.33% 5.33% 10.66%;
  // 上半期用
  // $bg1: #FFED8D;
  // $bg2: #FFE681;
  // 下半期用
  $bg1: #FFD3E1;
  $bg2: #FFC0E7;
  $bg3: transparent;
  background-color: $bg1;
  background-image:
    linear-gradient(45deg, $bg2 25%, $bg3 25%, $bg3 75%, $bg2 75%),
    linear-gradient(45deg, $bg2 25%, $bg3 25%, $bg3 75%, $bg2 75%);
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
  &__inn {
    max-width: 500px;
    margin: 0 auto;
  }
  &__head {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 16px;
    margin: 0 0 4.77%;
  }
  &__image {
    vertical-align: middle;
    float: left;
    width: 40%;
    max-width: 130px;
    margin-right: 12px;
    border-radius: 10%;
  }
  &__side {
    overflow: hidden;
  }
  &__name {
    display: inline-block;
    color: #FFE63C;
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    background: #412E2E;
    border-radius: 6px;
    padding: 4px 8px;
    margin: 0 0 10px;
  }
  &__title {
    font-weight: bold;
    font-size: 15px;
    line-height: 21px;
    color: #412E2E;
    margin: 0 0 8px;
    padding: 0 0 14px;
    border-bottom: 1px solid #412E2E;
  }
  &__price {
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    color: #412E2E;
    small {
      font-size: 10px;
    }
    .sbsc {
      color: #FF7497;
    }
  }
  &__text {
    clear: both;
    padding: 20px 0 0;
    font-size: 13px;
    line-height: 20px;
    text-align: justify;
    color: #412E2E;
  }
  &__notes {
    padding: 20px 0 0;
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
    color: #412E2E;
  }
}
.menuSub {
  margin: 0;
  padding: 24px;
  // 上半期用
  // background: #FF5E4E;
  // 下半期用
  background: #F05C80;
  border-radius: 12px;
  &__item {
    list-style: none;
    border-bottom: 1px dashed #DCDFE2;
    font-weight: bold;
    font-size: 14px;
    line-height: 1.4;
    padding: 12px 0 12px 1.05em;
    text-indent: -1.05em;
    color: #FFFFFF;
    &:first-child { padding-top: 0;}
    &:last-child { padding-bottom: 0; border: none;}
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 8px;
      background: #fff;
      margin-right: 2px;
      vertical-align: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/lpMenu.vue